import { baseURL } from "../../util/Constant";
import { getDesigner, getManager, getSewing } from "../redux/employeeSlice";
import { getMessage } from "../redux/messageSlice";

//Get All Designer
export const getAllEmployeeFetch = () => (dispatch) => {
    fetch(`${baseURL}/designer/get`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
       dispatch(getDesigner(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Get All Designer
export const getAllSewingFetch = () => (dispatch) => {
  fetch(`${baseURL}/sewing/get`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
     dispatch(getSewing(data));
    })
    .catch((error) => {
      console.log(error);
    });
};

//Get All Manager
export const getAllManagerFetch = () => (dispatch) => {
  fetch(`${baseURL}/manager/get`, { method: "GET" })
    .then((res) => res.json())
    .then((data) => {
      if (data.errorCode) {
        dispatch(getMessage(data.message));
        return;
      }
      
     dispatch(getManager(data));
    })
    .catch((error) => {
      console.log(error);
    });
};